/* ============================================
   DRIFT Theme by WEBEXP, LLC
   Email Capture Popup — Time-delayed modal
   https://webexp.dev
   ============================================ */

(function () {
  'use strict';

  var COOKIE_NAME = 'drift_popup_dismissed';

  /* ── DOM ── */
  var popup = document.querySelector('[data-email-popup]');
  if (!popup) return;

  var backdrop = popup.querySelector('[data-popup-backdrop]');
  var modal = popup.querySelector('[data-popup-modal]');
  var closeBtn = popup.querySelector('[data-popup-close]');
  var formState = popup.querySelector('[data-popup-form-state]');
  var successState = popup.querySelector('[data-popup-success-state]');
  var emailInput = popup.querySelector('[data-popup-email]');
  var submitBtn = popup.querySelector('[data-popup-submit]');
  var form = popup.querySelector('#drift-popup-form');

  var delay = (parseInt(popup.getAttribute('data-popup-delay'), 10) || 5) * 1000;
  var cookieDays = parseInt(popup.getAttribute('data-popup-cookie-days'), 10) || 7;

  /* ── Cookie helpers ── */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  /* ── Don't show if already dismissed ── */
  if (getCookie(COOKIE_NAME)) return;

  /* ── Don't show in theme editor ── */
  if (window.Shopify && window.Shopify.designMode) return;

  /* ── Open / Close ── */
  function open() {
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (emailInput) emailInput.focus();
  }

  function close(isSubscribed) {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    /* Subscribers: 365 days. Dismissed: merchant's cookie setting */
    setCookie(COOKIE_NAME, '1', isSubscribed ? 365 : cookieDays);
  }

  /* ── Event listeners ── */
  if (closeBtn) closeBtn.addEventListener('click', function () { close(false); });
  if (backdrop) backdrop.addEventListener('click', function () { close(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      close(false);
    }
  });

  /* ── Form submission ── */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      /* Disable button */
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '...';
      }

      /* Build form data */
      var formData = new FormData(form);

      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function () {
          /* Show success state */
          if (formState) formState.setAttribute('hidden', '');
          if (successState) successState.removeAttribute('hidden');

          /* Set cookie — subscriber never sees popup again */
          setCookie(COOKIE_NAME, '1', 365);

          /* Auto-close after 3 seconds */
          setTimeout(function () { close(true); }, 5000);
        })
        .catch(function () {
          /* Still show success — Shopify /contact often returns non-JSON */
          if (formState) formState.setAttribute('hidden', '');
          if (successState) successState.removeAttribute('hidden');
          setCookie(COOKIE_NAME, '1', 365);
          setTimeout(function () { close(true); }, 5000);
        });
    });
  }

  /* ── Trigger after delay ── */
  setTimeout(open, delay);

})();